import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Customers';
import CollectionPending from './components/Nics_Denies'; //Customers/Nics_Denies
import Object from './components/Customer'; //Take off S

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, locations, states,userAccess}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/nics_denies`}>
				<CollectionPending locations={locations} states={states}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object locations={locations} states={states} userAccess={userAccess} baseUrl={`${match.url}`}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
